import React from "react";
import { Eye } from "iconsax-react";
import Table from "../../table/Table";
import MainButton from "../../button/MainButton";
import StatusBadge from "../../table/StatusBadge";
import { Link } from "react-router-dom";
import { TableColumn } from "../../../utilities/types/support/types";
import MobileTicketCard from "./MobileTicketCard";
import { TransformTime } from "../../../utilities/helper/TransformPublishedAt";

interface TicketsTableProps {
  ticketsData: any[];
}

const TicketsTable: React.FC<TicketsTableProps> = ({ ticketsData }) => {
  const ticketsColumns: TableColumn<any>[] = [
    {
      key: "id",
      header: "Ticket Id",
      render: (value) => <span className="text-xs font-medium">#{value ? value : "-"}</span>,
    },
    {
      key: "user_email",
      header: "Business Email",
      render: (value) => <span className="text-xs">{value ? value : "-"}</span>,
    },
    {
      key: "title",
      header: "Subject",
      render: (value) => <span className="text-xs">{value ? value : "-"}</span>,
    },
    {
      key: "section",
      header: "Dep",
      render: (value) => <span className="text-xs">{value ? value : "-"}</span>,
    },
    {
      key: "status",
      header: "Status",
      render: (value) => (
        <div className="flex w-full">
          <StatusBadge statusText={value.toLowerCase()} />
        </div>
      ),
    },
    {
      key: "created_at",
      header: "Date",
      render: (value) => <span className="text-xs">{new Date(value * 1000).toLocaleDateString()}</span>,
    },
    {
      key: "time",
      header: "Time",
      render: (value, item) => <span className="text-xs">{item.created_at ? TransformTime(new Date(item.created_at * 1000).toISOString()) : "-"}</span>,
    },
    {
      key: "id",
      header: "Show Answer",
      render: (value, item) => (
        <Link to={`/admin/tickets/${item.id}`}>
          <MainButton type={item.message_action === "New Ticket" ? "primary" : "ghostOutlined"}>
            <Eye variant="Broken" className="mr-2 size-4" />
            Answer
          </MainButton>
        </Link>
      ),
    },
  ];

  return (
    <>
      <div className="block xl:hidden odd:*:bg-gorgonzola-blue-50 even:*:bg-white">
        {ticketsData.map((ticket) => (
          <MobileTicketCard key={ticket.id} ticket={ticket} />
        ))}
      </div>

      <div className="hidden w-full xl:block">
        <Table data={ticketsData} columns={ticketsColumns} />
      </div>
    </>
  );
};

export default TicketsTable;
